// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";
import { Select } from "@outschool/ui-legacy-component-library";
import _ from "lodash";
import React from "react";

import { AllOrganizationsQuery } from "../../../shared/generated/graphql";
import CharterSchoolFragment from "../../queries/CharterSchoolFragment";

type Org = AllOrganizationsQuery["organizations"][number];

interface OrganizationListProps {
  disabled: boolean;
  onSelect: (org: Org) => void;
}

const AllOrganizationsQueryString = gql`
  query AllOrganizations {
    organizations {
      ...CharterSchoolFragment
    }
  }
  ${CharterSchoolFragment}
`;

const OrganizationList: React.FC<OrganizationListProps> = ({
  disabled,
  onSelect
}: OrganizationListProps) => {
  const { loading, data } = useQueryWithPreviousData<AllOrganizationsQuery>(
    AllOrganizationsQueryString
  );

  const orgs = data?.organizations || [];
  const options = _.sortBy(orgs, org => org.name.toLowerCase()).map(toOption);
  return (
    <Select
      options={options}
      sx={{ width: "100%", marginBottom: "0.5em" }}
      onChange={onSelect}
      disabled={loading || disabled}
      placeholder={loading ? "Loading..." : "Pick organization"}
      includeBlank={false}
    />
  );
};

type OrgOption = { value: Org; label: string };

function toOption(value: Org): OrgOption {
  const label = value.state ? `${value.name} - ${value.state}` : value.name;
  return { value, label };
}

export default OrganizationList;
